import { useNavigate } from 'react-router';
import { Icon } from '../components/Icon.tsx';
import { LionMark } from '../components/LionMark.tsx';

export function Onboarding() {
  const nav = useNavigate();
  return (
    <div
      style={{
        minHeight: '100dvh',
        padding: '24px 22px 32px',
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--bg-app)',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <LionMark size={28} />
          <div style={{ fontSize: 13, color: 'var(--text-3)' }}>Install</div>
        </div>
        <button
          type="button"
          style={{ fontSize: 13, color: 'var(--accent)', fontWeight: 500 }}
          onClick={() => nav('/')}
        >
          Skip
        </button>
      </div>

      <div style={{ display: 'flex', gap: 4, marginBottom: 26 }}>
        <div style={{ flex: 1, height: 3, borderRadius: 2, background: 'var(--accent)' }} />
        <div style={{ flex: 1, height: 3, borderRadius: 2, background: 'var(--bg-sunken)' }} />
      </div>

      <h1
        className="lt-serif"
        style={{ fontSize: 30, lineHeight: 1.1, fontWeight: 400, letterSpacing: -0.015, margin: 0 }}
      >
        Add Lion Tracker
        <br />
        <span style={{ color: 'var(--accent)' }}>to your home screen.</span>
      </h1>
      <div style={{ fontSize: 14, color: 'var(--text-2)', marginTop: 12, lineHeight: 1.5 }}>
        iOS only delivers push notifications when the app is installed. Takes about 10 seconds.
      </div>

      <div
        style={{
          marginTop: 26,
          padding: 16,
          borderRadius: 20,
          background: 'var(--bg-card)',
          border: '1px solid var(--border)',
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
        }}
      >
        <Step
          n={1}
          label="Tap the share icon"
          visual={
            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: 11,
                background: 'var(--bg-sunken)',
                color: 'var(--accent)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Icon.share s={22} />
            </div>
          }
        />
        <Step
          n={2}
          label={
            <>
              Choose <span style={{ fontWeight: 600, color: 'var(--text-1)' }}>Add to Home Screen</span>
            </>
          }
          visual={
            <div
              style={{
                padding: '8px 12px',
                borderRadius: 11,
                background: 'var(--bg-sunken)',
                color: 'var(--text-1)',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontSize: 13,
                fontWeight: 500,
              }}
            >
              <span
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: 6,
                  border: '1.4px solid var(--text-2)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--text-2)',
                }}
              >
                <Icon.plus s={12} />
              </span>
              Home Screen
            </div>
          }
        />
        <Step
          n={3}
          label={
            <>
              Tap <span style={{ fontWeight: 600, color: 'var(--text-1)' }}>Add</span> in the top right
            </>
          }
          visual={
            <button
              type="button"
              style={{
                padding: '7px 14px',
                borderRadius: 8,
                background: 'var(--accent)',
                color: 'var(--accent-ink)',
                fontSize: 13,
                fontWeight: 600,
              }}
            >
              Add
            </button>
          }
        />
      </div>

      <div style={{ flex: 1 }} />

      <button
        type="button"
        className="lt-btn lt-btn-primary"
        style={{ width: '100%', padding: '14px 0', fontSize: 15 }}
        onClick={() => nav('/')}
      >
        I've added it · next
      </button>
    </div>
  );
}

function Step({ n, label, visual }: { n: number; label: React.ReactNode; visual: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '6px 4px' }}>
      <div
        style={{
          width: 22,
          height: 22,
          borderRadius: 999,
          background: 'var(--accent)',
          color: 'var(--accent-ink)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 12,
          fontWeight: 700,
          flexShrink: 0,
        }}
      >
        {n}
      </div>
      <div style={{ flex: 1, fontSize: 14, color: 'var(--text-2)' }}>{label}</div>
      {visual}
    </div>
  );
}
